import { SET_WEBSOCKET } from "./Type";

const initialState = {
    webSocketAPI: ''
}

export const notificationReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_WEBSOCKET:
            return { ...state, webSocketAPI: action.payload }
        default:
            return state;
    }
}